import { Component, OnInit, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { progressDetails } from "src/app/feature-modules/student-list/models/progressDetails";
import { ApiDataService } from "src/app/shared/services/api.service";
import { Location } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { StorageService } from "src/app/shared/services/storage.service";
import { Lesson } from "../../../lessons/models/lesson";
import { StudentSession } from "src/app/shared/models/student-session";
import confetti from 'canvas-confetti';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { enagagementTabs, passageConfig } from "../../constants/passage-constants";
import { UtilityService } from "src/app/shared/services/utility.service";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "engagement-review",
    templateUrl: "./engagement-review.component.html",
    styleUrls: ["./engagement-review.component.css"],
    standalone: false
})
//This component is under development and may contain unused code.
export class EngagementReview implements OnInit, OnDestroy {
  lessons: Lesson[] = [];
  selectedLesson: any = {};
  updateStudentProgressGroup: UntypedFormGroup;
  student: any;
  wordMissedFirst: number[] = [];
  wordMissedSecond: number[] = [];
  progressDetails: progressDetails;
  sessionId: any;
  tutorTipModal=false;
  reviewPercentageModal=true;
  sessionData: StudentSession;
  sessionEngageDetails=[]
  tutorTips="";
  confettiInterval=null;
  lessonName: string = '';
  ufliStrategyModal = false;
  ufliStrategyClickFlag = false;
  sanitizedWordUrl: SafeResourceUrl;
  lessonDetails;
  
  private ngUnsubscribe = new Subject <void>();
  constructor(
    private apiService: ApiDataService,
    private sanitizer: DomSanitizer,
    public _location: Location,
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    this.initializeForm();
  }

  handleUfliSTratergyModal(value: boolean) {
    this.ufliStrategyModal = value
    if (value) {
      this.ufliStrategyClickFlag = true
      this.clearConfetti()
    }else{
      this.getConfetti()
    }
  }
  
  getTutorTips() {
    try {
      this.apiService
        .getLessonTutorTips(this.sessionData["lesson"])
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res) => {
          if (res) {
            this.lessonDetails = res;
          }
        });
    } catch (error) {
      console.error("Error fetching tutor tip:", error);
    }
  }
  easyRead() {
    UtilityService.urlOpen(this.lessonDetails?.easy_read);
  }
  readWith() {
    UtilityService.urlOpen(this.lessonDetails?.read_with);
  }
  ngOnInit() {
    this.sessionData = StorageService.getSessionData();
    this.getTutorTips()
    this.getConfetti()
    this.sanitizedWordUrl = this.sanitizer.bypassSecurityTrustResourceUrl(passageConfig.ufliUrl);
    this.initializeForm();
    this.getSessionDetails()
  }

  tutorTipModalOpen(value:boolean){
    this.tutorTipModal=value
  }

  reviewModalClose(){
    this.reviewPercentageModal=false
  }

  @Output() changeTab = new EventEmitter<number>();
  
  goToTab(index: number) {
    this.changeTab.emit(index);
  }

  getSessionDetails() { 
    try {
      const lessonStudentIds = { 
        lessonId: this.sessionData["lesson"], 
        studentId: this.sessionData["student"]
      };

      this.apiService
      .getSessionDetails(lessonStudentIds)
      .subscribe((res) => {
        if (res && res?.data?.length) {

          const passagesArray = this.updateStudentProgressGroup.get('passages') as UntypedFormArray;
          while (passagesArray.length) {
            passagesArray.removeAt(0);
          }

          this.wordMissedFirst = [];
          this.wordMissedSecond = [];

          this.sessionEngageDetails = res.data.map((item) => {

            const firstReadWords = item?.first_read_words_index?.length || 0;
            const secondReadWords = item?.second_read_words_index?.length || 0;
            const wordsLearned = firstReadWords - secondReadWords;

            const passageGroup = this.fb.group({
              words_missed_first: new UntypedFormControl({ value: firstReadWords, disabled: false }),
              words_missed_second: new UntypedFormControl({ value: secondReadWords, disabled: false }),
              total_words_learned: new UntypedFormControl({ value: wordsLearned, disabled: false }),
              passage_id: new UntypedFormControl(item.passage_id || ''),
              passage_name: new UntypedFormControl(item.passage_name || ''),
              word_count: new UntypedFormControl(item.word_count || '')
            });

            passagesArray.push(passageGroup);

            this.wordMissedFirst.push(firstReadWords);
            this.wordMissedSecond.push(secondReadWords);

            return {
              ...item,
              words_learnt: item.first_read_words?.filter(word => !item.whip_words?.includes(word))
            };
          });

          this.updateStudentProgressGroup.updateValueAndValidity();
          this.cdr.detectChanges();
        }

        // For Training School students, automatically clear all engagement data
        // as soon as it has been loaded for display, so the lesson remains
        // available in HUG Classroom and no progress is permanently saved.
        if (this.sessionData?.isTrainingSchool) {
          this.clearTrainingSchoolEngagement();
        }
      });
    } catch (error) {
      console.error("Error fetching session details:", error);
    }
  }
  clearTrainingSchoolEngagement() {
    const studentId = this.sessionData["student"];
    if (!studentId) { return; }
    this.apiService.clearStudentEngagement(studentId).subscribe({
      error: (err) => console.error("Error clearing training school engagement:", err)
    });
  }
  async onBackToHugClassroom() {
    this.goToTab(enagagementTabs.startPage);
    StorageService.clearSessionData();
  }

  getAcumenData1(passage: any): number {
    const wordCount = passage?.word_count
    if (wordCount > 0) {
      const percentOne = Math.round((passage?.first_read_words_index?.length / wordCount) * 100);
      return 100 - percentOne;
    } else {
      return 0;
    }
  }

  getAcumenData2(passage: any): number {
    const wordCount = passage?.word_count
    if (wordCount > 0) {
      const percentTwo = Math.round((passage?.second_read_words_index?.length / wordCount) * 100);
      return 100 - percentTwo;
    } else {
      return 0;
    }
  }
  
  getConfetti() {
    const defaults = {
      spread: 360,
      ticks: 360,
      gravity: 1.8,
      decay: 0.9,
      startVelocity: 55,
      zIndex: 1000,
      colors: ['#ff0043', '#14fc56', '#00cfff', '#ffe600'],
    };

    this.confettiInterval = setInterval(function() {

      const originX = Math.random() * 0.8 + 0.1;
      const originY = Math.random() * 0.5 + 0.1; 

      confetti({
        ...defaults,
        particleCount: 100,
        origin: { x: originX, y: originY },
      });
    }, 500);
  }

  createpassageFormGroup(selectedLesson: any, passage: any) {
    return this.fb.group({
      words_missed_first: new UntypedFormControl({ value: 0, disabled: selectedLesson.id ? false : true }, [
        Validators.required,
      ]),
      words_missed_second: new UntypedFormControl({ value: 0, disabled: selectedLesson.id ? false : true }, [
        Validators.required,
      ]),
      total_words_learned: new UntypedFormControl({ value: 0, disabled: selectedLesson.id ? false : true }, [
        Validators.required,
      ]),
      second_read_complete: new UntypedFormControl({ value: "", disabled: selectedLesson.id ? false : true }, [
        Validators.required,
      ]),

      passage_id: new UntypedFormControl(passage.passage_id || ''),
      passage_name: new UntypedFormControl(passage.passage_name || ''),
      word_count: new UntypedFormControl(passage.word_count || ''),
    });

  }

  resetSelectedEngagement() {
    this.updateStudentProgressGroup.controls["mood_first"].setValue("");
    this.updateStudentProgressGroup.controls["mood_second"].setValue("");
    this.updateStudentProgressGroup.controls["volunteer_mood"].setValue("");
  }

  initializeForm() {
    this.updateStudentProgressGroup = new UntypedFormGroup({
      words_missed_first: new UntypedFormControl({ value: "0", disabled: true }),
      words_missed_second: new UntypedFormControl({ value: "0", disabled: true }),
      total_words_learned: new UntypedFormControl({ value: "0", disabled: true }),
      passages: this.fb.array([])
    });
  }
  createPassageGroups(passages) {
    return passages.map((passage) => {
      return this.fb.group({
        words_missed_first: new UntypedFormControl(passage.words_missed_first, [Validators.required]),
        words_missed_second: new UntypedFormControl(passage.words_missed_second, [Validators.required]),
        total_words_learned: new UntypedFormControl(passage.words_missed_first - passage.words_missed_second, [Validators.required]),
        passage_id: new UntypedFormControl(passage.passage_id),
        passage_name: new UntypedFormControl(passage.passage_name),
        word_count: new UntypedFormControl(passage.word_count),
      });
    });
  }

  clearConfetti() {
    this.confettiInterval && clearInterval(this.confettiInterval);
  }

  ngOnDestroy() {
    this.clearConfetti()
  }

  getPassageFormArray() {
    return this.updateStudentProgressGroup.get('passages') as UntypedFormArray;
  }

  getPassageFormGroup(index: number) {
    const formArray = this.getPassageFormArray();
    if (formArray && formArray.at(index)) {
      return formArray.at(index) as UntypedFormGroup;
    }
    return null;
  }

  getFormControlValue(index: number, controlName: string): number {
    const formGroup = this.getPassageFormGroup(index);
    if (formGroup && formGroup.get(controlName)) {
      return formGroup.get(controlName).value || 0;
    }
    return 0;
  }
}
